import React, { useRef, useState } from "react";
import sutherlandLogo from '../assets/img/sutherlandglobal.png';
import esealLogo from '../assets/img/big-logo.png';
import nonVegIcon from '../assets/img/non-veg.png';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const nonVegRecipe = {
  title: "LUMINA ALMOND KISSED CHICKEN Recipe",
  icon: nonVegIcon,
  ingredients: [
    "Chicken, curry cut – 1 kg",
    "Almonds – 200 g",
    "Cashews – 100 g",
    "Salt – to taste",
    "Saffron – 1 pinch",
    "Butter – 1 tablespoon",
    "Fresh cream – ½ cup",
    "Turmeric powder – ½ tablespoon",
    "Methi powder – 1 pinch",
    "Cardamom powder – 1 pinch",
    "Yellow chilli powder – 1 tablespoon",
    "Garam masala powder – 1 teaspoon",
    "Ginger-garlic paste – 1 tablespoon",
    "Coriander powder – 1 teaspoon",
    "Cumin powder – 1 teaspoon",
    "Cooking oil – 2 tablespoons",
    "Onion, chopped – 1 cup",
    "Green chilli, chopped – ¼ cup",
    "Coriander leaves, chopped – 1 tablespoon",
    "Tomato, chopped – 2 tablespoons",
    "Lemon – 1 no."
  ],
  method: [
    "Marinate the chicken with ginger-garlic paste, salt, a pinch of turmeric powder, and lemon juice. Cover and refrigerate for 1 hour.",
    "Soak the almonds in hot water for 30 minutes. Remove the skin.",
    "Soak the cashews in water for 15 minutes.",
    "Blend the soaked almonds and cashews together with a little water to make a smooth, fine paste. Keep aside.",
    "Heat a kadai and add the cooking oil. Once hot, add the chopped onion and sauté for about 5 minutes.",
    "Add the chopped green chilli and ginger-garlic paste. Sauté until the onion turns golden brown.",
    "Add turmeric powder and mix well. Add the marinated chicken and cook for approximately 5 minutes.",
    "Add the chopped tomato, yellow chilli powder, cumin powder, and coriander powder. Mix well and cook for another 5 minutes.",
    "Add the prepared almond-cashew paste and mix thoroughly.",
    "Add garam masala powder and 1 cup of water. Cover and cook on medium heat for approximately 10 minutes, or until the chicken is fully cooked and the gravy reaches the desired consistency.",
    "Reduce the heat and add butter, fresh cream, methi powder, and cardamom powder. Mix gently.",
    "Check and adjust the salt and spices according to taste.",
    "Finally, add the saffron, chopped fresh coriander, and some chopped almonds as garnish."
  ],
  serving: "Tawa Roti, Poori, Flavoured Rice, Jeera Rice, Naan"
};

export function NonVegRecipeUI() {
  const containerRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState(false);

const handleDownload = async () => {
  setIsDownloading(true);
  setIsDownloaded(false);
  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();

  try {
    const container = containerRef.current;
    if (!container) return;

    const clone = container.cloneNode(true);

    const page = document.createElement('div');
    page.style.position = 'absolute';
    page.style.top = '-9999px';
    page.style.left = '50%';
    page.style.transform = 'translateX(-50%)';
    page.style.background = '#fff';
    page.style.borderRadius = '12px';
    page.style.width = '92vw';
    page.style.maxWidth = '540px';   // slightly narrower to avoid clipping
    page.style.margin = '0';
    page.style.padding = '0.8rem 0.7rem';
    page.style.color = '#212c1d';
    page.style.fontFamily = 'Arial, sans-serif';
    page.style.fontSize = '0.75rem'; // reduce font size overall
    page.style.lineHeight = '1.32';

    // Center header only
    const header = clone.querySelector('.mobile-curry__header').cloneNode(true);
    header.style.width = '100%';
    header.style.textAlign = 'center';
    header.style.marginBottom = '0.4rem';
    const titleRow = header.querySelector('.mobile-curry__title-row');
    if (titleRow) {
      titleRow.style.justifyContent = 'center';
      titleRow.style.display = 'flex';
    }
    page.appendChild(header);

    // Style main sections for small font and minimal margin
    const mainSections = clone.querySelectorAll('main section');
    mainSections.forEach((section) => {
      const clonedSection = section.cloneNode(true);
      clonedSection.style.textAlign = 'left';
      clonedSection.style.fontSize = '0.75rem';
      clonedSection.style.marginBottom = '0.7rem';
      clonedSection.style.padding = '0';

      const lists = clonedSection.querySelectorAll('ul, ol');
      lists.forEach(list => {
        list.style.textAlign = 'left';
        list.style.paddingLeft = '1rem';
        list.style.marginLeft = '0';
        list.style.fontSize = '0.75rem';
      });

      page.appendChild(clonedSection);
    });

    document.body.appendChild(page);

    // Capture the page
    const canvas = await html2canvas(page, { scale: 3, useCORS: true, backgroundColor: null });
    let imgWidth = pdfWidth;
    let imgHeight = (canvas.height * imgWidth) / canvas.width;

    // Scale image if content is taller than PDF page
    if (imgHeight > pdfHeight) {
      imgHeight = pdfHeight;
      imgWidth = (canvas.width * imgHeight) / canvas.height;
    }

    const imgData = canvas.toDataURL('image/png');
    pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    pdf.save(`${nonVegRecipe.title}.pdf`);
    setIsDownloaded(true);

    document.body.removeChild(page);
  } catch (error) {
    console.error('PDF generation error:', error);
  } finally {
    setIsDownloading(false);
  }
};


  return (
    <div className="mobile-curry" ref={containerRef}>
      <header className="mobile-curry__header">
        <h1 className="mobile-curry__event">Lumina 2026 - Chef Special</h1>
        <div className="mobile-curry__title-row">
          <img src={nonVegRecipe.icon} alt="Non-Veg Icon" className="mobile-curry__food-icon" />
          <h2 className="mobile-curry__title">{nonVegRecipe.title}</h2>
        </div>
      </header>

      <main className="mobile-curry__card">
        <section>
          <h3>Ingredients</h3>
          <ol>
            {nonVegRecipe.ingredients.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ol>
        </section>
        <section>
          <h3>Method</h3>
          <ul>
            {nonVegRecipe.method.map((step, i) => (
              <li key={i}>
                <strong>Step {i + 1}:</strong> {step}
              </li>
            ))}
          </ul>
        </section>

        <section>
          <h3>Serving Suggestion</h3>
          <p className="suggestion_description">
            LUMINA ALMOND KISSED CHICKEN can be served hot with:
          </p>
          <p>{nonVegRecipe.serving}</p>
        </section>
      </main>

      <div style={{ textAlign: "center" }}>
        <style>{`
          @keyframes spin { to { transform: rotate(360deg); } }
          .spinner-icon {
            display: inline-block;
            width: 12px;
            height: 12px;
            border: 2px solid currentColor;
            border-top-color: transparent;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
            margin-right: 6px;
            vertical-align: middle;
          }
        `}</style>
        <button
          onClick={handleDownload}
          disabled={isDownloading}
          style={{
            backgroundColor: '#6c5ce7',
            border: 'none',
            borderRadius: '8px',
            color: 'white',
            padding: '8px 16px',
            fontSize: '12px',
            fontWeight: '600',
            cursor: isDownloading ? 'not-allowed' : 'pointer',
            opacity: isDownloading ? 0.8 : 1,
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            transition: 'background-color 0.3s ease',
            userSelect: 'none'
          }}
        >
         {isDownloading ? (
            <>
              <span className="spinner-icon" />
              Downloading...
            </>
          ) : (
            "Download"
          )}
        </button>
      </div>

      <footer className="mobile-curry__footer">
        <img src={sutherlandLogo} alt="Sutherland Logo" className="mobile-curry__footer-logo" />
        <div className="mobile-curry__powered">
          Developed by <img src={esealLogo} alt="eSeal Logo" className="mobile-curry__powered-logo" /> eSeal Team
        </div>
      </footer>
    </div>
  );
}
